import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-index"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "grid-view",
    style: {"position":"relative","flex":"1","overflow":"hidden auto"},
    ref: "el",
    onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateVisibleData && _ctx.updateVisibleData(...args))),
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle([{"position":"absolute","left":"0","right":"0","z-index":"-1"}, {minHeight:`${_ctx.maxScrollHeight}px`}])
    }, null, 4),
    _createElementVNode("div", {
      class: "content-wrapper",
      style: _normalizeStyle({gridTemplateColumns: _ctx.cellWidths}),
      onTouchend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.infiniteScrollEmitter && _ctx.infiniteScrollEmitter(...args))),
      onWheel: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.infiniteScrollEmitter && _ctx.infiniteScrollEmitter(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleData, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item-cell",
          key: index,
          "data-index": index
        }, [
          _renderSlot(_ctx.$slots, "default", { item: item }, () => [
            _createTextVNode(_toDisplayString(item), 1)
          ])
        ], 8, _hoisted_1))
      }), 128))
    ], 36)
  ], 544))
}